import { render, staticRenderFns } from "./paycheck-template.vue?vue&type=template&id=3dc5cdc7&scoped=true&"
import script from "./paycheck-template.vue?vue&type=script&lang=ts&"
export * from "./paycheck-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5cdc7",
  null
  
)

export default component.exports